import clsx from "clsx";
import { FC } from "react";
import { useTranslation } from "react-i18next";

import { SVG_MUI } from "@ryde/assets";

import { AccessControl } from "../../../access-control";
import { FramerTooltip } from "../../../tooltips";
import { RideStationRowLock } from "./ride-station-row-btns-lock";
import { StationHeaderRightIconsWrapperStyled } from "./ride-stations.styled";
import { useRideStationRowBtns } from "./use-ride-station-row-btns";

export const RideStationRowBtns: FC = () => {
  const { t } = useTranslation();
  const {
    isGreyed,
    deleteStationAvailable,
    canRemoveStationByScope,
    removeStationHandler,
  } = useRideStationRowBtns();

  return (
    <StationHeaderRightIconsWrapperStyled>
      {!isGreyed && <RideStationRowLock />}
      <AccessControl action="update" entity="ride">
        {deleteStationAvailable && (
          <FramerTooltip
            content={
              canRemoveStationByScope
                ? t("ride.RemoveStation")
                : t("errors.cannotRemovePassengersFromDifferentUnits")
            }
            rtlStrippedBottomLeftPlacement
          >
            <SVG_MUI.Trash2SVG
              data-e2e="station_delete_svg"
              className={clsx("trash", {
                pointer: canRemoveStationByScope,
                disabled: !canRemoveStationByScope,
              })}
              aria-disabled={canRemoveStationByScope ? undefined : true}
              onClick={
                canRemoveStationByScope ? removeStationHandler : undefined
              }
            />
          </FramerTooltip>
        )}
      </AccessControl>

      {/* Reason to hide task RYDE-4899 <RideStationRowComment /> */}
    </StationHeaderRightIconsWrapperStyled>
  );
};
